import SubTopicsCard from '../../api/sub_topics_card';
import QuestionCardAnswers from '../../api/question_card_answers';
const subTopicsCard = new SubTopicsCard();
const questionCardAnswers = new QuestionCardAnswers();

const subTopicsCardModule = {
    namespaced: true,
    state: {
        loading: false,
        subTopicsCards: [],
        subTopicCard: null,
        totalSubTopicsCards: 0,
        subTopicsCardLookups: [],
    },
    getters: {
        subTopicsCards: (state) => state.subTopicsCards,
        subTopicCard: (state) => state.subTopicCard,
        totalSubTopicsCards: (state) => state.totalSubTopicsCards,
        subTopicsCardLookups: (state) => state.subTopicsCardLookups,
        loading: (state) => state.loading,
    },
    mutations: {
        SET_LOADING: (state, loading) => {
            state.loading = loading;
        },
        SET_SUB_TOPICS_CARDS: (state, data) => {
            state.subTopicsCards = data;
        },
        SET_SUB_TOPIC_CARD: (state, data) => {
            state.subTopicCard = data;
        },
        SET_TOTAL_SUB_TOPICS_CARDS: (state, count) => {
            state.totalSubTopicsCards = count;
        },
        SET_SUB_TOPICS_CARD_LOOKUPS: (state, data) => {
            state.subTopicsCardLookups = data;
        },
    },
    actions: {
        GetSubTopicsCardLookups({ commit }, params) {
            return new Promise((resolve, reject) => {
                subTopicsCard.lookups(params).then(response => {
                    if (response) {
                        const data = Array.isArray(response) ? response : (response.subTopicsCards || response.sub_topics_cards || response.data || []);
                        commit('SET_SUB_TOPICS_CARD_LOOKUPS', data);
                    }
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        GetSubTopicsCards({ commit }, payload) {
            const query = (payload && payload.query) || {};
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                subTopicsCard.list(query).then(response => {
                    if (response) {
                        const data = Array.isArray(response) ? response : (response.subTopicsCards || response.sub_topics_cards || response.data || []);
                        commit('SET_SUB_TOPICS_CARDS', data);
                        commit('SET_TOTAL_SUB_TOPICS_CARDS', response.total || response.count || data.length || 0);
                    }

                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        CreateSubTopicsCard({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                subTopicsCard.store(payload).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        DeleteSubTopicsCard({ commit }, id) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                subTopicsCard.delete(id).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        UpdateSubTopicsCard({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                subTopicsCard.update(payload.id, payload.form).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        RestoreSubTopicsCard({ commit }, id) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                subTopicsCard.restore(id).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        ShowSubTopicsCard({ commit }, id) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                subTopicsCard.show(id).then(response => {
                    if (response) {
                        commit('SET_SUB_TOPIC_CARD', response.subTopicsCard || null);
                    }
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        StoreQuestionCardAnswer({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                questionCardAnswers.store(payload.questionCardAnswer).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        BulkStoreQuestionCardAnswers({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                questionCardAnswers.bulkStore(payload).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
    }
};

export default subTopicsCardModule;
